import { ApiConfig } from '@src/app/_global/domain/apiGateway';
var apigClientFactory = require('aws-api-gateway-client').default;
import { CustomResponse } from 'gc-backend';
import { AWSError } from 'aws-sdk/global';

export class ApiClient {
  getSessionStorageValue = (value: string): {} | void => {
    var valueString = sessionStorage.getItem(value);
    if (valueString) {
      return JSON.parse(valueString);
    }
  }
  callApiGateway = (config: ApiConfig): Promise<any | void> => {
    return new Promise((resolve, reject) => {
      var theData;
      if (config.creds) {
        config.creds.get(async (err: AWSError) => {
          if (err) {
            console.log(err);
            reject(err);
          } else {
            var apigClient = apigClientFactory.newClient({
              accessKey: config.creds.accessKeyId,
              secretKey: config.creds.secretAccessKey,
              sessionToken: config.creds.sessionToken,
              region: config.region,
              invokeUrl: config.url,
            });
            const result = await apigClient
              .invokeApi(
                config.parms,
                config.path,
                config.requestmethod,
                config.additionalParms,
                config.requestbody,
              )
              // tslint:disable-next-line:no-any
              .then(function(iamResult: any) {
                if (iamResult.data) {
                  if (iamResult.data.prodId) {
                    let response = iamResult.data as CustomResponse;
                    // theData = response;
                    // console.log('theData', theData);
                    return response;
                  } else {
                    // console.log('no prodId');
                    return iamResult.data;
                  }
                } else {
                  console.log('no result.data');
                  return undefined;
                }
              })
              .catch(function(data: any) {
                var responseData = data.message;
                console.error('IAM error result: ', responseData);
                console.error(data.stack);
                return responseData;
              });
            resolve(result);
          }
        });
      } else {
        reject('no config creds');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/_global/utility/apiUtils.ts